import type { FieldValues, Path, UseFormRegister } from 'react-hook-form';
import styled from 'styled-components';
import { BasicInputStyles } from './BasicInput';
import type { InputHTMLAttributes } from 'react';
import type { Merge } from 'simplytyped';

const Input = styled(BasicInputStyles)``;

const InputSpan = styled.span`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: ${({ theme }) => theme.margins.xs};
  //margin-right: -6px;
`;

type Props<Fields extends FieldValues> = Merge<
  InputHTMLAttributes<HTMLInputElement>,
  {
    errorMessage?: string;
    name: Path<Fields>;
    register?: UseFormRegister<Fields>;
    label?: string;
    inputSize?: string;
  }
>;

export const InputRange = <Fields extends FieldValues>(
  props: Props<Fields>
) => {
  const { errorMessage, name, inputSize, register, label, id } = props;
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  const registerFunc = register ? register : () => {};
  return (
    <InputSpan>
      <Input
        id={id ? `${id}-input-range` : undefined}
        errorMessage={errorMessage}
        alt={label}
        {...props}
        name={`${name}.min`}
        inputSize={inputSize}
        type="number"
        {...registerFunc(`${name}.min` as Path<Fields>, {
          setValueAs: (value) =>
            value === undefined || value === '' ? undefined : parseFloat(value)
        })}
      />
      <span> - </span>
      <Input
        errorMessage={errorMessage}
        alt={label}
        {...props}
        type="number"
        inputSize={inputSize}
        name={`${name}.max`}
        {...registerFunc(`${name}.max` as Path<Fields>, {
          setValueAs: (value) =>
            value === undefined || value === '' ? undefined : parseFloat(value)
        })}
      />
    </InputSpan>
  );
};
